import type { ReactNode } from "react";

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/shared/ui/alert-dialog";
import { Button } from "@/shared/ui/button";

interface ConfirmationDialogProps {
  open: boolean;
  title: ReactNode;
  description: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  pending?: boolean;
  pendingLabel?: ReactNode;
  unknown?: boolean;
  destructive?: boolean;
  onConfirm: () => void;
  onRetryUnknown?: () => void;
  onOpenChange: (open: boolean) => void;
}

export function ConfirmationDialog({
  open,
  title,
  description,
  confirmLabel,
  cancelLabel = "CANCEL",
  pending = false,
  pendingLabel,
  unknown = false,
  destructive = true,
  onConfirm,
  onRetryUnknown,
  onOpenChange,
}: ConfirmationDialogProps) {
  return (
    <AlertDialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!pending || unknown || nextOpen) onOpenChange(nextOpen);
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={pending && !unknown}>
            {unknown ? "CLOSE" : cancelLabel}
          </AlertDialogCancel>
          {unknown ? (
            <Button type="button" onClick={onRetryUnknown}>
              RETRY CHECK
            </Button>
          ) : (
            <Button
              type="button"
              variant={destructive ? "destructive" : "default"}
              pending={pending}
              pendingLabel={pendingLabel ?? confirmLabel}
              onClick={onConfirm}
            >
              {confirmLabel}
            </Button>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
